import styled from 'styled-components';

const DonutChartWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${({ height }) => (height ? height : 150)}px;
  width: 100%;

  .semi-donut {
    --percentage: 0;
    --fill: #ff0;
    width: ${({ height }) => (height ? height * 2 : 300)}px;
    height: ${({ height }) => (height ? height : 150)}px;
    position: relative;
    color: #000;
    font-size: ${({ fontSize }) => (fontSize ? fontSize : 22)}px;
    font-weight: 700;
    overflow: hidden;
    ${'' /* color: var(--fill); */}
    display: flex;
    align-items: flex-end;
    justify-content: center;
    box-sizing: border-box;
    &:after {
      content: '';
      width: ${({ height }) => (height ? height * 2 : 300)}px;
      height: ${({ height }) => (height ? height * 2 : 300)}px;
      border: ${({ barSize }) => (barSize ? barSize : 50)}px solid;
      border-color: rgba(0, 0, 0, 0.10) rgba(0, 0, 0, 0.10) var(--fill)
        var(--fill);
      position: absolute;
      border-radius: 50%;
      left: 0;
      top: 0;
      box-sizing: border-box;
      transform: rotate(calc(1deg * (-45 + var(--percentage) * 1.8)));
    }
  }
  .multi-graph {
    width: ${({ height }) => (height ? height * 2 : 300)}px;
    height: ${({ height }) => (height ? height : 150)}px;
    position: relative;
    color: #000;
    font-size: ${({ fontSize }) => (fontSize ? fontSize : 22)}px;
    font-weight: 700;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    overflow: hidden;
    box-sizing: border-box;
    &:before {
      content: '';
      width: ${({ height }) => (height ? height * 2 : 300)}px;
      height: ${({ height }) => (height ? height : 150)}px;
      border: ${({ barSize }) => (barSize ? barSize : 50)}px solid
        rgba(0, 0, 0, 0.10);
      border-bottom: none;
      position: absolute;
      box-sizing: border-box;
      transform-origin: 50% 0%;
      border-radius: ${({ height }) => (height ? height * 2 : 300)}px
        ${({ height }) => (height ? height * 2 : 300)}px 0 0;
      left: 0;
      top: 0;
    }
    .graph {
      width: ${({ height }) => (height ? height * 2 : 150)}px;
      height: ${({ height }) => (height ? height : 150)}px;
      border: ${({ barSize }) => (barSize ? barSize : 50)}px solid var(--fill);
      border-top: none;
      position: absolute;
      transform-origin: 50% 0% 0;
      border-radius: 0 0 ${({ height }) => (height ? height * 2 : 300)}px
        ${({ height }) => (height ? height * 2 : 300)}px;
      left: 0;
      top: 100%;
      z-index: 5;
      transform: rotate(calc(1deg * (var(--percentage) * 1.8)));
      box-sizing: border-box;
      cursor: pointer;
    }
  }
`;

const DonutChart = ({
  data,
  height,
  centerLabel,
  fontSize = 22,
  barSize,
  barColor = '#FF3D00'
}) => {
  if (!data) return null;
  if (data.length === 0) return null;

  if (data.length === 1) {
    const { label, value, color } = data[0];
    return (
      <DonutChartWrapper height={height} barSize={barSize} fontSize={fontSize}>
        <div
          className='semi-donut'
          style={{ '--percentage': value, '--fill': color || barColor }}
        >
          {centerLabel || label}
        </div>
      </DonutChartWrapper>
    );
  }

  return (
    <DonutChartWrapper height={height} barSize={barSize} fontSize={fontSize}>
      <div class='multi-graph'>
        {centerLabel}
        {data.map((item, index) => {
          const { label, value, color } = item;
          return (
            <div
              className='graph'
              dataName={label}
              style={{ '--percentage': value, '--fill': color || barColor }}
            ></div>
          );
        })}
      </div>
    </DonutChartWrapper>
  );
};

export default DonutChart;
